export default __webpack_public_path__ + "static/media/Stack.1b2db566.svg";